export const _dominationColor = "crimson";
export const _complement = "white";
export const _accent = "#3f50b5";
export const _hoverColor = "rgb(201, 14, 51)";
